import { motion, useScroll, useTransform } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "../ui/Button";

export default function Hero() {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 200]);
  const opacity = useTransform(scrollY, [0, 300], [1, 0]);

  return (
    <div className="relative h-screen bg-black overflow-hidden">
      {/* Parallax Background */}
      <motion.div
        style={{ y, opacity }}
        className="absolute inset-0 w-full h-full"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/60 z-10" />
        <img
          src="https://images.unsplash.com/photo-1519699047748-de8e457a634e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
          alt="Luxury Hair Care"
          className="w-full h-full object-cover object-center"
        />
      </motion.div>

      {/* Decorative Elements */}
      <div className="absolute inset-0 z-20">
        <div className="absolute top-0 left-0 w-1/3 h-1/3 bg-gradient-to-br from-gold-500/10" />
        <div className="absolute bottom-0 right-0 w-1/3 h-1/3 bg-gradient-to-tl from-gold-500/10" />
      </div>

      {/* Content */}
      <div className="relative z-30 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="space-y-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="space-y-4"
              >
                <span className="inline-block px-6 py-2 text-lg md:text-xl font-medium tracking-wider text-white bg-[#DB5461] rounded-full shadow-lg">
                  LUXURY HAIR CARE
                </span>
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white leading-tight">
                  Natural Beauty,{" "}
                  <span className="text-gold-400">Elevated</span>
                </h1>
              </motion.div>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="text-xl text-gray-300 max-w-xl"
              >
                Discover our premium collection of hair products designed to
                transform your hair care journey into a luxurious experience.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="flex flex-wrap gap-4"
              >
                <Link to="/products">
                  <Button
                    size="lg"
                    className="!bg-[#DB5461] hover:!bg-[#DB5461]/90 text-white px-8 py-4"
                  >
                    Explore Collection
                  </Button>
                </Link>
                <Link to="/about">
                  <Button
                    variant="outline"
                    size="lg"
                    className="!border-2 !border-[#DB5461] !text-[#DB5461] hover:!bg-[#DB5461] hover:!text-white px-8 py-4 transition-all duration-300"
                  >
                    Our Story
                  </Button>
                </Link>
              </motion.div>
            </div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative hidden lg:block"
            >
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl h-[500px]">
                <img
                  src="https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743593582/babs-about_ysjcis.jpg"
                  alt="Premium Hair Products"
                  className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-gold-500/20 rounded-full blur-2xl" />
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gold-500/20 rounded-full blur-2xl" />
            </motion.div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - adjust position */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1,
          delay: 1,
          repeat: Infinity,
          repeatType: "reverse",
        }}
        className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-30"
      >
        <div className="w-6 h-10 rounded-full border-2 border-gold-500 p-1">
          <div className="w-1.5 h-1.5 bg-gold-500 rounded-full animate-bounce mx-auto" />
        </div>
      </motion.div>
    </div>
  );
}
